import { render, staticRenderFns } from "./LocationReservation.vue?vue&type=template&id=683a592c&"
import script from "./LocationReservation.vue?vue&type=script&lang=js&"
export * from "./LocationReservation.vue?vue&type=script&lang=js&"
import style0 from "./LocationReservation.vue?vue&type=style&index=0&id=683a592c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports